export const sortTypes = {
    ascent: 'Ascent',
    descent: 'Descent',
    none: 'none',
};
